import React from 'react';

function Mobile() {
  return <div>ManageOperators</div>;
}

export default Mobile;
